var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TrackSelectWizard',{attrs:{"to":{ name: "track editor transform" },"target":_vm.target,"introText":"Please choose how you would like to find tracks to edit.","showFieldEditButton":true,"showDeleteButton":true}})}
var staticRenderFns = []

export { render, staticRenderFns }